import { Theme, css } from '@emotion/react';

export const popoverPaperRoot = ({ spacing }: Theme) => css`
  .MuiPaper-root {
    margin-top: ${spacing(1)}px;
  }
`;

export const popoverContent = ({ spacing, typography }: Theme) => css`
  padding: ${spacing(2.5)}px;
  min-width: ${typography.pxToRem(268)};
`;
